module.exports = __webpack_public_path__ + "static/media/anteia-particle-1080x1920-edit.a1795d58.webm";